import { CheckApiKey, CheckPolicy, jwtVerify, Resource } from '../../framework/permission-util'
import { RT } from '../permissions'
import Executive from '../../framework/rmi-util'
import { register } from '../../framework/rmi-server-util'
import { exportOrderItemsToExcel } from './BulkCancellationTechnical'
	
export default class BulkCancellationExecutive extends Executive {

	initServer() {
	}

	@CheckPolicy()
	async exportOrderItemsToExcel(orderItems: any[], productName?: string, eventDate?: string, timeSlot?: string, jobData?: any): Promise<Buffer> {
		return await exportOrderItemsToExcel(orderItems, productName, eventDate, timeSlot, jobData)
	}
}

register(BulkCancellationExecutive)
